
import HomeUI from './components/HomeUI'

const HomePage = () => {
    return <HomeUI />
}

export default HomePage
